import { DataItemType, FormControlType } from "@cloudpivot/form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "./components/pc-input-number.vue";
import mobile from "./components/mobile-input-number.vue";
const info = {
    title: "数值",
    type: "number",
    icon: "h-icon-all-number",
    dataItemType: DataItemType.Number,
    formControllerType: FormControlType.Number,
    group: "基础控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
